// Presents the add/edit account dialog fields and submit/cancel actions.
import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

interface SheetAccountDialogProps {
  open: boolean;
  mode: "create" | "edit";
  name: string;
  alias: string;
  onClose: () => void;
  onNameChange: (value: string) => void;
  onAliasChange: (value: string) => void;
  onSave: () => void;
}

export default function SheetAccountDialog({
  open,
  mode,
  name,
  alias,
  onClose,
  onNameChange,
  onAliasChange,
  onSave,
}: SheetAccountDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{mode === "edit" ? "Edit Account" : "Add Account"}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1, display: "grid", gap: 2 }}>
          <TextField
            label="Name"
            value={name}
            onChange={(event) => onNameChange(event.target.value.slice(0, 200))}
            inputProps={{ maxLength: 200 }}
            autoFocus
            fullWidth
          />
          <TextField
            label="Account #"
            value={alias}
            onChange={(event) => onAliasChange(event.target.value)}
            fullWidth
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
